import React from "react";
import WorkStatusApplication from "../components/workStatusApp/WorkStatusApplication";

const WorkStatusAppPage = () => {
    return <div>
       <WorkStatusApplication test={false}/>
    </div>;
}

export default WorkStatusAppPage  ;